// 获取url参数值
export function getUrlCode (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    let href = window.location.hash.split('?')[1]
    if (href) {
        var r = href.match(reg)
        if (r != null) {
            return unescape(r[2])
        }
        return ''
    }
    return ''
}
// 获取url参数值
export function getUrlCodeNew (name, url) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    let href = url.split('?')[1]
    if (href) {
        var r = href.match(reg)
        if (r != null) {
            return unescape(r[2])
        }
        return ''
    }
    return ''
}



// WEBPACK FOOTER //
// ./src/utils/urlFormat.js